// Auto-generated from card.spec.js
export default {
  "tagName": "ui-card",
  "content": [
    "icon",
    "header",
    "description",
    "subheader",
    "image"
  ],
  "contentAttributes": [
    "icon",
    "header",
    "description",
    "subheader",
    "image"
  ],
  "variations": [
    "fluid",
    "link",
    "horizontal"
  ],
  "states": [
    "hover",
    "focused",
    "disabled"
  ],
  "settings": [
    "href"
  ],
  "attributes": [
    "icon",
    "header",
    "description",
    "subheader",
    "image",
    "hover",
    "focused",
    "disabled",
    "fluid",
    "link",
    "horizontal",
    "href"
  ],
  "optionAttributes": {
    "disabled": "disabled",
    "clickable-disabled": "disabled"
  },
  "propertyTypes": {
    "icon": "string",
    "header": "string",
    "description": "string",
    "subheader": "string",
    "image": "string",
    "hover": "boolean",
    "focused": "boolean",
    "disabled": "string",
    "fluid": "boolean",
    "link": "boolean",
    "horizontal": "boolean",
    "href": "string"
  },
  "allowedValues": {
    "disabled": [
      "disabled",
      "clickable"
    ]
  },
  "attributeClasses": [
    "icon",
    "disabled"
  ],
  "defaultValues": {
    "href": ""
  }
};
